// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"18":"aff22440","104":"a9b3843b","198":"9f04aaed","214":"b418c7b5","399":"0d48f9e5","442":"df4a1704","453":"3b6a2137","490":"7ec546c3","521":"97d08277","529":"a1da55d9","565":"6e457a97","710":"ddfbfebd","747":"b51d07a2","828":"6cec0201","975":"e2adcf97"}[chunkId] + ".chunk.js";
};